module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_2048.c79cf091.jpg";